import { gql } from "apollo-angular";

export default gql`
  query CompaniesOverview($list: CompaniesList!, $filter: CompaniesFilter!) {
    companies(list: $list, filter: $filter) {
      metaData {
        count
      }
      objects {
        id
        name
        enabledProducts
      }
    }
  }
`;
